import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { consumptionService } from "../../../../Services/AccountingServices/consumption.service";
import ResultModal from "../../../Common/ResultModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as dateHelper from "../../../../Helpers/DateHelper";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SpinnerLoading from "../../../Common/SpinnerLoading";
import ActionModal from "../../../Common/ActionModal";
import ProductsFilterModal from "../../../Common/ProductsFilterModal";
import { AuthContext } from "../../../../Contexts/AuthContext";
import { GlobalContext } from "../../../../Contexts/GlobalContextProvider";
import XLSX from "xlsx";
import { activeCurrencyByDate } from "../../../../Helpers/CurrencyConverter";

const ConsumptionDetails = (props) => {
  const { isMobile } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { useAccounting } = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [update, setUpdate] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [initValue, setInitValue] = useState({
    date: null,
    storeId: 0,
    storeName: "",
    note: "",
    documentNumber: null,
    documentGuid: "",
    parentGuid: null,
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false
      )
    );

    let oldDeleted2 = oldDeleted.filter((f) =>
      filterProducts.some((item) => item.productGuid === f.productGuid)
    );

    //vraćam ih na isActive true
    oldDeleted2.forEach((el) => (el.isActive = true));

    //uklanjanje duplikata
    oldDeleted = oldDeleted.filter((f) =>
      oldDeleted2.some((item) => item.productGuid !== f.productGuid)
    );

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid)
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid)
    );

    let newProducts = addedProducts.map((prod) => ({
      documentDetailGuid: prod.documentDetailGuid,
      productGuid: prod.productGuid,
      productName: prod.productName,
      priceOut: prod.price,
      quantityOut: Number(prod.quantity),
      isActive: true,
      unitOfMeasure: prod.unitMeasureName,
    }));

    newArr = newArr.concat(newProducts);

    let shouldRemove = newArr.filter(
      (e) => e.documentDetailGuid === null && e.isActive === false
    );

    newArr = newArr.filter((el) => !shouldRemove.includes(el));

    setIsDisabled(false);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, priceOut, unitOfMeasure) => {
    setProducts([
      ...products,
      {
        documentDetailGuid: null,
        productGuid,
        productName,
        priceOut,
        quantityOut: 0,
        isActive: true,
        unitOfMeasure,
      },
    ]);
    setIsDisabled(false);
  };

  const onSubmit = (data) => {
    consumptionService
      .documentUpdate(
        initValue.documentGuid,
        initValue.date,
        initValue.storeId,
        data.note,
        products
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateSuccess-Title",
            text: "InitialState-ResultModal-UpdateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-UpdateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCancel = () => {
    history.push("/consumption");
  };

  const handleClose = () => {
    setModal({ show: false });
    history.push("/consumption");
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    consumptionService
      .getDocumentById(props.match.params.documentId)
      .then((res) => {
        if (res.data.data !== null) {
          setInitValue({
            ...initValue,
            date: res.data.data.date,
            storeId: Number(res.data.data.storeId),
            storeName: res.data.data.storeName,
            note: res.data.data.note,
            documentNumber: res.data.data.documentNumber,
            priceListId: res.data.data.priceListId,
            tenantId: res.data.data.tenantId,
            documentGuid: res.data.data.documentGuid,
            parentGuid: res.data.data.parentGuid,
          });
        }
        consumptionService
          .documentDetails(props.match.params.documentId)
          .then((res) => {
            setProducts(res.data.data);
            setIsLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => err);
  }, []);

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const handleLockDocument = () => {
    setActionModal({
      title: "InitialState-DocumentLock-Title",
      text: "InitialState-DocumentLock-Text",
      confirmBtn: "Confirm-Lock",
      confirmAction: confirmLock,
      show: true,
    });
  };

  const handleCancelDocument = () => {
    setActionModal({
      title: "InitialState-DocumentCancel-Title",
      text:
        initValue.parentGuid != null
          ? "Document-Cancel-Forbbiden"
          : "InitialState-DocumentCancel-Text",
      confirmBtn: initValue.parentGuid != null ? "" : "Confirm-Cancel",
      confirmAction: initValue.parentGuid != null ? () => false : confirmCancel,
      show: true,
    });
  };

  const handleDeleteDocument = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmLock = () => {
    consumptionService
      .documentLock(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockSuccess-Title",
            text: "InitialState-ResultModal-LockSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-LockError-Title",
            text: "InitialState-ResultModal-LockError-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = () => {
    consumptionService
      .documentDelete(props.match.params.documentId)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: "InitialState-ResultModal-DeleteError-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const confirmCancel = () => {
    consumptionService
      .documentCancel(props.match.params.documentId)
      .then((res) => {
        setActionModal({ ...modal, show: false });
        if (res && res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelSuccess-Title",
            text: "InitialState-ResultModal-CancelSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CancelError-Title",
            text: "InitialState-ResultModal-CancelError-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      searchable: false,
      hidden: initValue.documentNumber ? true : false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          let newArr = [...products];
          let item = newArr.find((p) => p.productGuid === row.productGuid);
          item.isActive = false;

          setProducts(newArr);
          setIsDisabled(false);
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      editable: false,
    },
    {
      dataField: "unitOfMeasure",
      text: translator("Jed. mjere"),
      editable: false,
      searchable: false,

      hidden: Boolean(isMobile),
    },
    {
      dataField: "quantityOut",
      text: `${translator("InitialState-Quantity")}*`,
      searchable: false,
      editable: initValue.documentNumber ? false : true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
  ];

  const exportExcelFunction = () => {
    var ws_name = `Povratnica ${initValue.documentNumber}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [translator("InvIssReport-Filters-Tenants"), "Prodajno mjesto"],
      ["", initValue.storeName],
      [translator("InvoiceCashBalancePDF-Date"), "Broj dokumenta"],
      [dateHelper.formatUtcToDate(initValue.date), initValue.documentNumber],
      ["Dobavljač", initValue.partnerName],
      [
        translator("Proizvod"),
        `Prodajna cijena (${activeCurrencyByDate(initValue.date)})`,
        "Količina",
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [x.productName, x.priceOut, x.quantityOut];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];
    XLSX.utils.book_append_sheet(wb, ws, "Povratnica");
    XLSX.writeFile(wb, ws_name);
  };

  return (
    <>
      <CardWrap subtitle={translator("DocumentDetails")}>
        {!isLoading ? (
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label className="boldedDocNumber">
                      <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                      {initValue.documentNumber
                        ? initValue.documentNumber
                        : translator("Document-NotLocked")}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Date")}:</b>{" "}
                      {dateHelper.formatUtcToDate(initValue.date)}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("InitialState-Store")}:</b>{" "}
                      {initValue.storeName}
                    </label>
                  </div>
                  <div className="form-group">
                    <label>
                      <b>{translator("InitialState-Note")}:</b>
                    </label>
                    <textarea
                      name="note"
                      ref={register({ maxLength: 250 })}
                      className="form-control"
                      rows={4}
                      id="textArea"
                      defaultValue={initValue.note}
                      onChange={() => setIsDisabled(false)}
                      disabled={initValue.documentNumber ? true : false}
                    ></textarea>
                    {errors.note && errors.note.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </div>
                </div>
              </fieldset>
              <div
                class="custom-card-footer row"
                style={{
                  borderTop: "1px solid #ccc",
                  paddingTop: "22px",
                }}
              >
                <label class="control-label col-md-12">
                  * {translator("DangerArea")}
                </label>
                <div className="col-md-6">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLockDocument();
                    }}
                  >
                    {translator("Btn-Conclude")}
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    disabled={!initValue.documentNumber ? true : false}
                    className="btn btn-outline-secondary btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCancelDocument();
                    }}
                  >
                    {translator("Btn-CancelDoc")}
                  </button>
                </div>

                <div className="col-md-12 mt-3">
                  <button
                    disabled={initValue.documentNumber ? true : false}
                    className="btn btn-danger btn-block"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDocument();
                    }}
                  >
                    {translator("Btn-RemoveDoc")}
                  </button>
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      exportExcelFunction();
                    }}
                    disabled={initValue.documentNumber ? false : true}
                    className="btn btn-outline-secondary btn-block"
                  >
                    {translator("Preuzmi dokument")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-Items")}
                </legend>
                <ToolkitProvider
                  keyField="productGuid"
                  data={products.filter((item) => item.isActive === true)}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      {!initValue.documentNumber ? (
                        <div className="form-group">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowFilterModal(true);
                            }}
                          >
                            <span className="icon icon-filter"></span>{" "}
                            {translator("Filter")}
                          </button>
                          &nbsp;
                          <span className="text-danger ml-2">
                            {translator(modalValidationMsg)}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                          className="col-md-12"
                        />
                      </div>

                      <hr />
                      <BootstrapTable
                        {...props.baseProps}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              </fieldset>
            </div>
            <div
              className="container-fluid mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                {translator("POS-New_EditPOS-Close")}
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                disabled={isDisabled}
                type="submit"
              >
                {translator("POS-New_EditPOS-Save")}
              </button>
            </div>
          </form>
        ) : (
          <SpinnerLoading />
        )}
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      {initValue.date !== null && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={initValue.storeId}
          documentOption={2}
          prodList={products.filter((item) => item.isActive === true)}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
    </>
  );
};

export default ConsumptionDetails;
